import { Field, Int } from '@nestjs/graphql'
import { BaseModelWithoutUserDto } from '../base/baseModelWithoutUser.dto'
import { ArcClaimDto, ArcDto, ArcReviewDto, ArcReviewSiteDto } from '../arc'
import { ObjectType } from '@nestjs/graphql'

@ObjectType()
export class NotificationDto extends BaseModelWithoutUserDto {
  @Field()
  code!: string

  @Field()
  permissionPreferenceKey!: string

  @Field(t => Int)
  typeFlags!: number

  @Field()
  active!: boolean

  @Field()
  lastQueuedDate!: Date

  @Field(t => Int, { nullable: true })
  userAwaitingNotificationCount?: number

  @Field(t => Int, { nullable: true })
  userNotificationCount?: number

  @Field(t => Int, { nullable: true })
  status?: number

  @Field({ nullable: true })
  statusDate?: Date

  @Field({ nullable: true })
  templateId?: string

  @Field(t => ArcDto, { nullable: true })
  arc?: ArcDto

  @Field(t => Int, { nullable: true })
  arcId?: number

  @Field(t => ArcClaimDto, { nullable: true })
  arcClaim?: ArcClaimDto

  @Field(t => Int, { nullable: true })
  arcClaimId?: number

  @Field(t => ArcReviewDto, { nullable: true })
  arcReview?: ArcReviewDto

  @Field(t => Int, { nullable: true })
  arcReviewId?: number

  @Field(t => ArcReviewSiteDto, { nullable: true })
  arcReviewSite?: ArcReviewSiteDto

  @Field(t => Int, { nullable: true })
  arcReviewSiteId?: number
}
